import React from 'react';

export const ProjectIcon = ({ size = 20 }: { size?: number }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox='0 0 18 17'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M6.46875 1.6875H11.5312C11.6859 1.6875 11.8125 1.81406 11.8125 1.96875V3.375H6.1875V1.96875C6.1875 1.81406 6.31406 1.6875 6.46875 1.6875ZM4.5 1.96875V3.375H2.25C1.00898 3.375 0 4.38398 0 5.625V9H6.75H11.25H18V5.625C18 4.38398 16.991 3.375 15.75 3.375H13.5V1.96875C13.5 0.882422 12.6176 0 11.5312 0H6.46875C5.38242 0 4.5 0.882422 4.5 1.96875ZM18 10.125H11.25V11.25C11.25 11.8723 10.7473 12.375 10.125 12.375H7.875C7.25273 12.375 6.75 11.8723 6.75 11.25V10.125H0V14.625C0 15.866 1.00898 16.875 2.25 16.875H15.75C16.991 16.875 18 15.866 18 14.625V10.125Z'
        fill='currentColor'
      />
    </svg>
  );
};

export const FlagIcon = ({ size = 14 }: { size?: number }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox='0 0 14 14'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M2.26562 8.48865C2.26562 8.48865 2.83146 7.92281 4.52896 7.92281C6.22646 7.92281 7.35812 9.05448 9.05562 9.05448C10.7531 9.05448 11.319 8.48865 11.319 8.48865V1.69865C11.319 1.69865 10.7531 2.26448 9.05562 2.26448C7.35812 2.26448 6.22646 1.13281 4.52896 1.13281C2.83146 1.13281 2.26562 1.69865 2.26562 1.69865V8.48865Z'
        stroke='#6B7280'
        strokeWidth='1.13167'
      />
      <path
        d='M2.26562 12.4491V8.48828'
        stroke='#6B7280'
        strokeWidth='1.13167'
      />
    </svg>
  );
};

export const UserIcon = ({
  size = 14,
  color = '#6B7280',
}: {
  size?: number;
  color?: string;
}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox='0 0 14 14'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M6.78677 6.78839C8.03678 6.78839 9.0501 5.77506 9.0501 4.52505C9.0501 3.27505 8.03678 2.26172 6.78677 2.26172C5.53677 2.26172 4.52344 3.27505 4.52344 4.52505C4.52344 5.77506 5.53677 6.78839 6.78677 6.78839Z'
        stroke={color}
        strokeWidth='1.13167'
      />
      <path
        d='M2.26562 11.3169C2.26562 9.05354 4.52896 7.92188 6.79229 7.92188C9.05562 7.92188 11.319 9.05354 11.319 11.3169'
        stroke={color}
        strokeWidth='1.13167'
      />
    </svg>
  );
};

export const ContactAssociationIcon = ({ size = 33 }: { size?: number }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox='0 0 33 33'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <rect width='32.98' height='32.98' rx='9' fill='#8B5CF6' fillOpacity='0.14' />
      <path
        d='M16.7703 16.3101C18.1988 16.3101 19.3569 15.152 19.3569 13.7234C19.3569 12.2948 18.1988 11.1367 16.7703 11.1367C15.3417 11.1367 14.1836 12.2948 14.1836 13.7234C14.1836 15.152 15.3417 16.3101 16.7703 16.3101Z'
        stroke='#8B5CF6'
        strokeWidth='1.29333'
      />
      <path
        d='M11.5977 21.4855C11.5977 18.8988 14.1843 17.6055 16.771 17.6055C19.3577 17.6055 21.9443 18.8988 21.9443 21.4855'
        stroke='#8B5CF6'
        strokeWidth='1.29333'
      />
    </svg>
  );
};

export const CompanyAssociationIcon = ({ size = 33 }: { size?: number }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox='0 0 33 33'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <rect width='32.98' height='32.98' rx='9' fill='#60A5FA' fillOpacity='0.14' />
      <path
        d='M21.2959 10.4922H12.2426C11.5283 10.4922 10.9492 11.0712 10.9492 11.7855V20.8389C10.9492 21.5531 11.5283 22.1322 12.2426 22.1322H21.2959C22.0102 22.1322 22.5892 21.5531 22.5892 20.8389V11.7855C22.5892 11.0712 22.0102 10.4922 21.2959 10.4922Z'
        stroke='#60A5FA'
        strokeWidth='1.29333'
      />
      <path
        d='M14.8292 10.4922V22.1322M18.7092 10.4922V22.1322M10.9492 14.3722H22.5892M10.9492 18.2522H22.5892'
        stroke='#60A5FA'
        strokeWidth='1.29333'
      />
    </svg>
  );
};

export const BriefcaseIcon = ({ size = 17 }: { size?: number }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox='0 0 17 17'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M14.166 4.95801H2.83268C2.05028 4.95801 1.41602 5.59227 1.41602 6.37467V13.458C1.41602 14.2404 2.05028 14.8747 2.83268 14.8747H14.166C14.9484 14.8747 15.5827 14.2404 15.5827 13.458V6.37467C15.5827 5.59227 14.9484 4.95801 14.166 4.95801Z'
        stroke='#8B5CF6'
        strokeWidth='1.13333'
      />
      <path
        d='M11.3327 14.875V3.54167C11.3327 3.16594 11.1834 2.80561 10.9177 2.53993C10.6521 2.27426 10.2917 2.125 9.91602 2.125H7.08268C6.70696 2.125 6.34662 2.27426 6.08095 2.53993C5.81527 2.80561 5.66602 3.16594 5.66602 3.54167V14.875'
        stroke='#8B5CF6'
        strokeWidth='1.13333'
      />
    </svg>
  );
};

export const CheckCircleIcon = ({
  size = 14,
  color = '#10B981',
}: {
  size?: number;
  color?: string;
}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox='0 0 14 14'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M6.75 13.5C7.63642 13.5 8.51417 13.3254 9.33311 12.9862C10.1521 12.647 10.8962 12.1498 11.523 11.523C12.1498 10.8962 12.647 10.1521 12.9862 9.33311C13.3254 8.51417 13.5 7.63642 13.5 6.75C13.5 5.86358 13.3254 4.98583 12.9862 4.16689C12.647 3.34794 12.1498 2.60382 11.523 1.97703C10.8962 1.35023 10.1521 0.853032 9.33311 0.513813C8.51417 0.174594 7.63642 -1.32087e-08 6.75 0C4.95979 2.66762e-08 3.2429 0.711159 1.97703 1.97703C0.711159 3.2429 0 4.95979 0 6.75C0 8.54021 0.711159 10.2571 1.97703 11.523C3.2429 12.7888 4.95979 13.5 6.75 13.5ZM6.576 9.48L10.326 4.98L9.174 4.02L5.949 7.88925L4.28025 6.21975L3.21975 7.28025L5.46975 9.53025L6.05025 10.1108L6.576 9.48Z'
        fill={color}
      />
    </svg>
  );
};

export const BuildingIcon = ({ size = 17 }: { size?: number }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox='0 0 17 17'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M2.125 14.875H14.875M3.54167 14.875V4.95833L8.5 2.125L13.4583 4.95833V14.875M6.375 6.375H7.08333M9.91667 6.375H10.625M6.375 9.20833H7.08333M9.91667 9.20833H10.625M6.375 12.0417H7.08333M9.91667 12.0417H10.625'
        stroke='#A78BFA'
        strokeWidth='1.13333'
      />
    </svg>
  );
};
